export default "__VITE_ASSET__175d504f__"